/// <amd-module name="Artifacts/Root/utils/RestApi" />
import { CommonConstants } from "Artifacts/Root/Constants";
import {
  getCurrentSelectedProjectId,
  getCurrentSelectedProjectName,
} from "Artifacts/Root/helpers/ProjectHelpers";
import { IVssPageContext } from "VSS/Platform/Context";
import { getServiceLocation } from "VSS/Platform/Location";
import { Uri, combineUrlPaths } from "VSS/Platform/Util/Url";

export interface IRestApiRoutes {
  locationId: string;
  resource: string;
  routeTemplate: string;
}

const ApisRelativePath = "_apis";

export function generatePackagingServiceRestApiUri(
  pageContext: IVssPageContext,
  path: string,
  publicAccessMapping: string,
  ignoreApisRelativePath = false,
  includeProject = false,
): string {
  const packagingServiceRootPath = getServiceLocation(
    pageContext,
    CommonConstants.PackagingServiceInstanceId,
  );
  let project = null;

  if (includeProject) {
    const projectName = getCurrentSelectedProjectName(pageContext);
    // Project names can contain spaces, which mean they need to be encoded before they are returned to be
    // used in any client. However, mvn currently doesn't support having encoded urls for `mvn deploy` command.
    // This is a known bug in maven and is being tracked here: https://issues.apache.org/jira/browse/MDEPLOY-261
    // To prevent older mvn clients from breaking, we check here if the projectName needs to be encoded (in case
    // it has a space or any special character), and if so we return the project guid instead for all clients.
    if (projectName) {
      project =
        encodeURI(projectName) === projectName
          ? projectName
          : getCurrentSelectedProjectId(pageContext);
    } else {
      project = getCurrentSelectedProjectId(pageContext);
    }
  }

  return generateServiceRestApiUri(packagingServiceRootPath, path, ignoreApisRelativePath, project)
    .absoluteUri;
}

export function generateServiceRestApiUri(
  serviceRootPath: string,
  path: string,
  ignoreApisRelativePath = false,
  project: string | null = null,
): Uri {
  let url = "";
  if (project) {
    url = combineUrlPaths(
      serviceRootPath,
      project,
      ignoreApisRelativePath ? "" : ApisRelativePath,
      path,
    );
  } else {
    url = combineUrlPaths(serviceRootPath, ignoreApisRelativePath ? "" : ApisRelativePath, path);
  }

  return new Uri(decodeURIComponent(url));
}
